var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import "./CreateSessionDialog.component.css";
import { useEffect, useState } from "react";
import { getLayoutList, getSessionList, createSessionLayout, createSessionWorld } from "../../services/session.service";
import { LabelledElement } from "../../components/labelled-element/LabelledElement.component";
import { updateSessionListStore } from "../../store/sessionlist.store";
import { GenericDialog } from "../generic-dialog/GenericDialog.component";
import { MessageService } from "../../services/message.service";
import Select from "react-select";
import { getReactSelectStyleClasses } from "../../style/style-functions";
import { useTranslation } from "react-i18next";
export function CreateSessionDialog({ onCancel, onCreated, size = "wide" }) {
    const [layoutList, setLayoutList] = useState([]);
    const [selectedLayout, setSelectedLayout] = useState();
    const [sessionName, setSessionName] = useState("");
    const [inputInvalid, setInputInvalid] = useState(false);
    const [sessionNamesInUse, setSessionNamesInUse] = useState([]);
    const { t } = useTranslation();
    const updateSessionNamesInUse = () => __awaiter(this, void 0, void 0, function* () {
        getSessionList()
            .then((sessions) => {
            setSessionNamesInUse(sessions.map((session) => session.name.toLowerCase()));
        })
            .catch((error) => {
            console.error(error);
            MessageService.showMessage("error", t("sessionview:error-get-session-list", "Could not get session list"));
        });
    });
    useEffect(() => {
        getLayoutList()
            .then((layouts) => {
            setLayoutList(layouts);
            if (layouts.length > 0) {
                setSelectedLayout(layouts[0]);
            }
        })
            .catch((error) => {
            console.error(error);
            MessageService.showMessage("error", t("sessionview:error-get-layout-list", "Could not get layout list"));
        });
        void updateSessionNamesInUse();
    }, []);
    useEffect(() => {
        if (sessionName.length === 0) {
            setInputInvalid(true);
        }
        else {
            setInputInvalid(sessionNamesInUse.includes(sessionName.toLowerCase()));
        }
    }, [sessionName]);
    const handleCreateSession = () => __awaiter(this, void 0, void 0, function* () {
        if (!selectedLayout) {
            console.error("No layout selected");
            MessageService.showMessage("error", t("sessionview:error-no-layout", "No layout selected"));
            return;
        }
        if (inputInvalid) {
            console.error("Invalid session name");
            MessageService.showMessage("error", t("sessionview:error-invalid-session-name", "Invalid session name"));
            return;
        }
        let createSession;
        if (selectedLayout.isWorld) {
            createSession = createSessionWorld;
        }
        else {
            createSession = createSessionLayout;
        }
        const errorCreateSession = t("sessionview:error-create-session", "Session could not be created");
        createSession(sessionName, selectedLayout.name)
            .then((response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.ok) {
                if ((yield response.text()) === "api.error.session.name.duplicated") {
                    setInputInvalid(true);
                    void updateSessionNamesInUse();
                }
                else {
                    console.error("Unhandled error: " + response);
                    MessageService.showMessage("error", errorCreateSession);
                }
            }
            else {
                void updateSessionListStore();
                onCreated(sessionName);
            }
        }))
            .catch((error) => {
            console.error(error);
            MessageService.showMessage("error", errorCreateSession);
        });
    });
    const onWorldSelectChanged = (option) => {
        setSelectedLayout(layoutList.find((d) => d.name === (option === null || option === void 0 ? void 0 : option.value)));
    };
    const createWorldOptions = () => layoutList.map((layout) => ({
        value: layout.name,
        label: layout.name
    }));
    return (React.createElement(GenericDialog, { title: t("sessionview:create-session-dialog-title", "New Session"), confirmAllowed: !!selectedLayout && !inputInvalid, confirmText: t("sessionview:create-session-dialog-button-confirm", "Create"), confirmTooltipDisabled: t("sessionview:create-session-dialog-button-confirm-tooltip-disabled", "Please enter a session name and select a VR world template"), width: size, onConfirm: handleCreateSession, onCancel: onCancel },
        React.createElement("div", { className: "create-session-dialog-content" },
            React.createElement(LabelledElement, { label: t("sessionview:create-session-dialog-input-name", "Session Name") },
                React.createElement("input", { className: inputInvalid ? "input-invalid" : "", type: "text", onChange: (event) => {
                        setSessionName(event.target.value);
                    }, autoFocus: true })),
            React.createElement(LabelledElement, { label: t("sessionview:create-session-dialog-select-world-template", "World template") },
                React.createElement(Select, { onChange: onWorldSelectChanged, value: selectedLayout ? { value: selectedLayout.name, label: selectedLayout.name } : undefined, options: createWorldOptions(), classNames: getReactSelectStyleClasses(), menuPlacement: "auto", menuPortalTarget: document.body })))));
}
